import React from 'react';
import { Quote } from 'lucide-react';
export function SocialProofSection() {
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="relative rounded-3xl overflow-hidden bg-[#1e4d7b] text-white shadow-2xl" data-id="element-137">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-138">
            <div className="relative h-64 lg:h-auto" data-id="element-139">
              <img src="https://cdn.magicpatterns.com/uploads/ifrCzfzjyC7d7mdQue3BR5/HERO_5.png" alt="Madre tranquila" className="absolute inset-0 w-full h-full object-cover" data-id="element-140" />
              <div className="absolute inset-0 bg-gradient-to-r from-[#1e4d7b]/50 to-transparent lg:hidden" data-id="element-141"></div>
            </div>

            <div className="p-8 md:p-16 flex flex-col justify-center relative" data-id="element-142">
              <Quote className="h-12 w-12 text-[#4a90c2] opacity-50 mb-6" data-id="element-143" />
              <blockquote className="text-xl md:text-2xl font-medium leading-relaxed mb-8" data-id="element-144">
                "No es solo eliminar piojos. Es recuperar la paz mental en casa:
                dormir tranquilos, sin revisar cabezas todo el tiempo."
              </blockquote>
              <div className="flex items-center gap-4" data-id="element-145">
                <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center text-lg font-bold" data-id="element-146">
                  M
                </div>
                <div data-id="element-147">
                  <div className="font-bold" data-id="element-148">María G.</div>
                  <div className="text-blue-200 text-sm" data-id="element-149">Madre de 2 hijos</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}